export default __webpack_public_path__ + "static/media/pt.b899196f.jpg";